// Times from the server are UTC and carry no offset ("2026-10-21T10:22:59"). Read plainly they would be taken as local time; this reads
// them as UTC, so that they show in the user's own time.
export function parseServerUtc(value: string): Date {
  return new Date(/[zZ]|[+-]\d\d:\d\d$/.test(value) ? value : `${value}Z`);
}
